<template>
  <div class="chart-sidebar-menu">
    <div class="chart-sidebar-menu__container">
      <div class="chart-sidebar-menu__top-menu">
        <a href="/contents" class="mb-48 flex">
          <VerticalLogo class="chart-sidebar-menu__logo" />
        </a>

        <DatabaseIcon
          @click.prevent="toggleTab('database_documentation')"
          class="chart-sidebar-menu__database-icon mb-48 pointer grey-6" />

        <CodeIcon
          @click.prevent="toggleTab('sql_reference')"
          class="chart-sidebar-menu__database-icon mb-48 pointer grey-6" />
      </div>

      <div class="chart-sidebar-menu__bottom-menu">
      </div>
    </div>

    <transition name="slide-toggle">
      <div
        class="chart-sidebar-menu__dataset-documentation"
        v-if="activeTab === 'database_documentation'">
        <DatasetDocumentation
          @close="close" />
      </div>
    </transition>

    <transition name="slide-toggle">
      <div
        class="chart-sidebar-menu__sql-reference"
        v-if="activeTab === 'sql_reference'">
        <SQLReference
          @close="close" />
      </div>
    </transition>
  </div>
</template>

<script>
import VerticalLogo from "@images/svgs/mobile_header_logo.svg";
import DatabaseIcon from "@images/font_awesome/database-light.svg";
import CodeIcon from "@images/font_awesome/code-light.svg";
import DatasetDocumentation from "components/chart/dataset-documentation";
import SQLReference from "components/chart/sql-reference";

export default {
  components: {
    VerticalLogo,
    DatabaseIcon,
    CodeIcon,
    DatasetDocumentation,
    SQLReference
  },
  data() {
    return {
      activeTab: null
    };
  },
  methods: {
    toggleTab(name) {
      if(this.activeTab === name) {
        this.close();
      } else {
        this.activeTab = name;
      }
    },
    close() {
      this.activeTab = null;
    }
  }
}
</script>

<style lang="scss">
.chart-sidebar-menu {
  position: relative;
  height: 100%;

  background-color: $grey-10;

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: $px16 $px16 $px16;
    position: relative;
    z-index: 5000;
    height: 100%;

    background-color: $grey-10;
  }

  &__top-menu {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  &__bottom-menu {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  &__logo {
    width: $px32;
  }

  &__database-icon {
    width: $px24;

    &:hover {
      opacity: 0.7;
    }
  }

  &__dataset-documentation {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    z-index: 2000;
    transform: translateX(100%);

    background-color: $grey-10;

    transition: all .5s ease;
  }

  &__sql-reference {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    z-index: 2000;
    transform: translateX(100%);

    background-color: $grey-10;

    transition: all .5s ease;
  }
}

.slide-toggle-enter-active {
  transition: all .5s ease;
}

.slide-toggle-enter {
  transform: translateX(0%);
}

.slide-toggle-enter-to {
  transform: translateX(100%);
}

.slide-toggle-leave {
  transform: translateX(100%);
}

.slide-toggle-leave-to {
  transform: translateX(0%);
}
</style>
